import _get from 'lodash/get';
export const getOwnerData = owner => {
  if (_get(owner, 'id')) {
    const data = {
      listingCode: owner.id
    };

    // remove all undefined
    return Object.entries(data).reduce((acc, _ref) => {
      let [key, value] = _ref;
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
  return {};
};
export default {
  getOwnerData
};